export class FileUtils {
    /**
     * Valida via regexp se uma string é uma string base64 ou não.
     * Suporta validação pela base64 e/ou base64 com mimetype por exemplo: data:image/png;base64.
     * @param data string para validação
     */
    public static IsBase64(data: string, maxSizeInMB: number = 1): Boolean {

        if (typeof data !== 'string' || !data) {
            return false;
        }

        // Converte o limite de MB para caracteres (1 caractere Base64 ≈ 0.75 bytes)
        // Fórmula: maxSizeInBytes = maxSizeInMB * 1024 * 1024
        //          maxLengthToCheck = maxSizeInBytes / 0.75 (pois Base64 aumenta em ~33%)
        const maxLengthToCheck = Math.floor((maxSizeInMB * 1024 * 1024) / 0.75);

        // Verifica se a string é muito grande (opcional, mas recomendado)
        if (data.length > maxLengthToCheck) {
            console.warn(`A string Base64 excede o limite de ${maxSizeInMB}MB. Verificando apenas os primeiros ${maxLengthToCheck} caracteres.`);
            data = data.substring(0, maxLengthToCheck);
        }


        // Remove o prefixo MIME (se existir)
        const mimePrefix = /^data:[^;]+;base64,/;
        if (mimePrefix.test(data)) {
            data = data.replace(mimePrefix, '');
        }

        // Verifica se a string restante é um Base64 válido
        // Usa uma regex mais eficiente e evita problemas com strings grandes
        const base64Only = /^[A-Za-z0-9+/]+={0,2}$/;

        // Verifica se a string contém apenas caracteres Base64 válidos
        // Divide a verificação em partes para evitar estouro de pilha
        const chunkSize = 1_000_000; // Verifica 1MB por vez
        for (let i = 0; i < data.length; i += chunkSize) {
            const chunk = data.substring(i, i + chunkSize);
            if (!base64Only.test(chunk)) {
                return false;
            }
        }

        return true;
    }

    /**
    * Verifica se a string enviada é uma base64 se não for retorna o valor de imediato sem alterações.
    * Caso seja adiciona o mime type "'data:image/jpeg;base64,'"
    * @param base64 string base 64
    * @param mime string mime base64 ex. 'data:image/jpeg;base64,'
    * @returns 
    */
    public static AddMimeTypeBase64(base64: string, mime: string = 'data:image/jpeg;base64,'): string {
        if (!this.IsBase64(base64)) return base64;

        return mime + base64;
    }

    /**
     * Verifica se a string enviada é uma base64, se não for retorna o valor de imediato sem alterações.
     * Caso seja, remove o mime tipe "'data:image/jpeg;base64,'".
     * @param base64 string base64
     */
    public static RemoveMimeTypeBase64(base64: string): string {

        if (!this.IsBase64(base64)) return base64;

        try {
            const result = base64.split(',')[1];

            return result;
        }
        catch (error) { return base64; }
    }

    /**
     * Retorna Base64 de um file reference form.
     * @param file File
     * @returns 
     */
    public static GetBase64(file: File): Promise<string | ArrayBuffer> {

        return new Promise((resolve, reject) => {

            const reader = new FileReader();

            reader.readAsDataURL(file);

            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    /**
     * 
     * @param url 
     * @returns 
     */
    public static async GetURLBase64(url: string): Promise<string | ArrayBuffer> {
        const res = await fetch(url);
        const blob = await res.blob();

        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.readAsDataURL(blob);

            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    /**
    * Verifica se a extensão do documento é aceite
    * @param file 
    * @param extensions extensões permitidas, por defeito já estão definidas
    */
    public static VerifyFileExtension(fileInput, extensions: string[] = [".pdf", ".doc", ".docx", ".jpg", ".jpeg", ".png"]): boolean {

        const files = fileInput instanceof HTMLInputElement
            ? fileInput.files
            : fileInput;

        if (!files || files.length === 0) {
            return false;
        }

        const fileName = files[0].name;


        // Normalizar extensões (converter para minúsculas e garantir ponto)
        const normalizedExtensions = extensions.map(ext =>
            ext.toLowerCase().startsWith('.') ? ext.toLowerCase() : `.${ext.toLowerCase()}`
        );

        const extensionsPattern = normalizedExtensions.join('|');
        const regex = new RegExp(`(${extensionsPattern})$`, 'i');

        // Validar extensão
        const isValid = regex.test(fileName);

        // Reset do input apenas se inválido
        if (!isValid && fileInput instanceof HTMLInputElement) {
            fileInput.value = '';
            fileInput.name = 'Sem ficheiro selecionado';
        }

        return isValid;
    }

    /**
     * Verifica se o tamanho do documento não excede o máximo permitido
     * @param file 
     * @param maxSizeFile tamanho máximo dos ficheiros, casa não se indique esta igualado a 1 
     */
    public static VerifyFileSize(fileInput, maxSizeFile: number = 2): boolean {
        // const files: FileList = file?.files;

        const files = fileInput instanceof HTMLInputElement
            ? fileInput.files
            : fileInput;

        // Verificar se há arquivos selecionados
        if (!files || files.length === 0) {
            return false;
        }

        if (files?.length === 0) {
            return false;
        }

        const mb = +(files[0].size / (1024 * 1024)).toFixed(3);

        if (mb > maxSizeFile) {

            if (fileInput instanceof HTMLInputElement) {
                fileInput.value = null;
                fileInput.name = 'Sem ficheiro selecionado';
            }

            return false;
        }

        return true;
    }

    /**
    * Verifica se o tamanho do documento não excede o máximo permitido
    * @param file 
    * @param maxSizeInKB tamanho máximo dos ficheiros, casa não se indique esta igualado a 1 
    */
    public static VerifyFileSizeKB(file, maxSizeInKB: number = 1024): boolean {

        const files: FileList = file?.files || file;

        if (!files || files?.length === 0) {
            return false;
        }

        const selectFile = files[0];
        const fileSizeInKB = Math.round(selectFile.size / 1024);

        if (selectFile && fileSizeInKB > maxSizeInKB) {

            file.value = null;
            file.name = 'Sem ficheiro selecionado';
            return false;
        }

        return true;
    }


    /**
    * Cópia o valor da string para o clipboard
    * @param val 
    */
    public static CopyString(val: string) {
        let selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
    }

    /**
     * cria e devolve blob do url
     * @param url 
     * @returns 
     */
    public static async GetFileFromUrl(url: string): Promise<Blob> {
        return new Promise(resolve => {

            fetch(url)
                .then(res => res.blob()) // Gets the response and returns it as a blob
                .then(blob => {
                    resolve(blob);
                });
        })
    }

    /**
     * DEVOLVE BASE64 do ficheiro
     * @param url 
     * @returns 
     */
    public static async GetBase64FromUrl(url: string): Promise<string> {
        const response = await fetch(url);
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result as string);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    }

    /**
     * 
     * @param url 
     * @returns 
     */
    public static GetFileNameFromUrl(url: string): string {
        return url.split('/').pop() || '';
    }

    /**
     * 
     * @param input 
     * @param size 
     * @param returnBase64
     * @returns 
     */
    public static ResizeToSquare(input: File | string, size: number = 400, returnBase64: boolean = true): Promise<Blob | string> {

        return new Promise((resolve, reject) => {
            const img = new Image();

            // verificar se input é base64 ou File
            if (typeof input === 'string') {
                // já é base64
                img.src = input;
            } else {
                // é File → ler como base64
                const reader = new FileReader();
                reader.onload = (e: any) => {
                    img.src = e.target.result;
                };
                reader.onerror = (err) => reject(err);
                reader.readAsDataURL(input);
            }

            img.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = size;
                canvas.height = size;
                const ctx = canvas.getContext('2d');

                if (!ctx) {
                    reject('Canvas context not available');
                    return;
                }

                // fundo branco (ou transparente se preferires)
                ctx.fillStyle = '#ffffff';
                ctx.fillRect(0, 0, size, size);

                // calcular escala proporcional
                const scale = Math.min(size / img.width, size / img.height);
                const newWidth = img.width * scale;
                const newHeight = img.height * scale;

                // centralizar a imagem
                const offsetX = (size - newWidth) / 2;
                const offsetY = (size - newHeight) / 2;

                ctx.drawImage(img, offsetX, offsetY, newWidth, newHeight);

                if (returnBase64) {
                    resolve(canvas.toDataURL('image/jpeg', 0.9));
                } else {
                    canvas.toBlob((blob) => {
                        if (blob) resolve(blob);
                        else reject('Image compression failed');
                    }, 'image/jpeg', 0.9);
                }
            };

            img.onerror = (err) => reject(err);
        });
    }
}